import React from 'react';
import Link from 'gatsby-link';
import DeskTopLinks from './DeskTopLinks';
import MobileLinks from './MobileLinks';
import OuterDiv from '../styledComponents/OuterDiv';

const HeaderDiv = OuterDiv.extend`
  padding-top: 0.2rem;
  padding-bottom: 0;
  height: 4.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  h1 {
    margin-bottom: 8px;
  }
  @media (max-width: 700px) {
    height: 3.2rem;
    padding-right: 1rem;
    padding-left: 1rem;
    h1 {
      font-size: 1.4rem;
    }
  }
`;

const Header = ({ siteTitle }) => (
  <HeaderDiv>
    <h1>
      <Link to="/">{siteTitle}</Link>
    </h1>
    <DeskTopLinks />
    <MobileLinks />
  </HeaderDiv>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js